import { Fragment } from "react";

import { type NotesLine, parseShowNotes } from "@/dashboard/lib/show-notes";

const renderLine = (line: NotesLine) =>
  line.map((span, i) => {
    let node: React.ReactNode = span.text;
    if (span.italic) node = <em>{node}</em>;
    if (span.bold) node = <strong>{node}</strong>;
    // biome-ignore lint/suspicious/noArrayIndexKey: spans are positional
    return <Fragment key={i}>{node}</Fragment>;
  });

/**
 * DJ show notes rendered from their minimal markdown — bold, italic, hard
 * line breaks, blank-line paragraphs. The parser is the dashboard's; only
 * the markup here is the marketing site's own.
 */
const ShowNotes = ({ text }: { text: string }) => (
  <>
    {parseShowNotes(text).map((paragraph, p) => (
      // biome-ignore lint/suspicious/noArrayIndexKey: paragraphs are positional
      <p className="station__blurb" key={p}>
        {paragraph.map((line, l) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: lines are positional
          <Fragment key={l}>
            {l > 0 && <br />}
            {renderLine(line)}
          </Fragment>
        ))}
      </p>
    ))}
  </>
);

export default ShowNotes;
